import { useCallback } from "react";
import { useColorMode } from "@chakra-ui/react";
import { setColorPreferences } from "src/services/application";

type ThemeColorPrefs = {
  primary: string;
  headerFooter: string;
};

type ApplicationColors = {
  light?: ThemeColorPrefs;
  dark?: ThemeColorPrefs;
};

export function useThemePreferenceSync(colors?: ApplicationColors) {
  const { colorMode, toggleColorMode } = useColorMode();

  const applyThemePreference = useCallback(
    (shouldBeLight: boolean) => {
      const targetPrefs = shouldBeLight ? colors?.light : colors?.dark;
      if (targetPrefs) {
        setColorPreferences(
          shouldBeLight ? { ...targetPrefs, isLight: true } : targetPrefs,
        );
      }

      const isLightNow = colorMode === "light";
      if (shouldBeLight !== isLightNow) {
        toggleColorMode();
      }
    },
    [colorMode, colors, toggleColorMode],
  );

  return {
    colorMode,
    applyThemePreference,
  };
}
